var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main-layout"},[(_vm.$route.meta.mainAnchor)?_c('a',{staticClass:"main-layout__skip",attrs:{"href":_vm.$route.meta.mainAnchor}},[_vm._v("Skip to content")]):_vm._e(),_c('AppBar'),_vm._t("default"),_c('Footer')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }